import React, { useState, useMemo, useEffect } from 'react';
import Layout from '../../components/ui/Layout';


import Icon from '../../components/AppIcon';

import AlertFeed from './components/AlertFeed';
import AlertDetails from './components/AlertDetails';
import AlertCategories from './components/AlertCategories';
import AlertFilterBar from './components/AlertFilterBar';
import notificationService from '../../services/notificationService';
import TaskManagementPanel from '../../pages/property-management-dashboard/components/TaskManagementPanel';
import NotificationToast from '../../pages/property-management-dashboard/components/NotificationToast';
import SubHeader from '../../components/ui/SubHeader';
import ActionBoxes from '../../components/ui/ActionBoxes';
import AllAlertsActionsModal from './components/AllAlertsActionsModal';
import ClientFollowUpActionsModal from './components/ClientFollowUpActionsModal';
import ContractDeadlineActionsModal from './components/ContractDeadlineActionsModal';
import PropertyExpirationActionsModal from './components/PropertyExpirationActionsModal';
import PaymentReminderActionsModal from './components/PaymentReminderActionsModal';
import MaintenanceAlertActionsModal from './components/MaintenanceAlertActionsModal';
import ExportAlertsModal from './components/ExportAlertsModal';
import AlertSettingsModal from './components/AlertSettingsModal';
import realtimeNotificationService from '../../services/realtimeNotificationService';

const StaffAlertAndNotificationDashboard = () => {
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [selectedAlert, setSelectedAlert] = useState(null);
  const [toastNotification, setToastNotification] = useState(null);
  const [filters, setFilters] = useState({
    search: '',
    priority: 'all',
    status: 'all',
    dateRange: 'all',
    assignedStaff: 'all'
  });
  const [isQuickMenuOpen, setIsQuickMenuOpen] = useState(false);
  const [showNewContractModal, setShowNewContractModal] = useState(false);
  
  // Modal states for each action box
  const [showAllAlertsModal, setShowAllAlertsModal] = useState(false);
  const [showClientFollowUpModal, setShowClientFollowUpModal] = useState(false);
  const [showContractDeadlineModal, setShowContractDeadlineModal] = useState(false);
  const [showPropertyExpirationModal, setShowPropertyExpirationModal] = useState(false);
  const [showPaymentReminderModal, setShowPaymentReminderModal] = useState(false);
  const [showMaintenanceAlertModal, setShowMaintenanceAlertModal] = useState(false);
  const [showExportAlertsModal, setShowExportAlertsModal] = useState(false);
  const [showAlertSettingsModal, setShowAlertSettingsModal] = useState(false);

  // Real-time notification states
  const [realtimeNotification, setRealtimeNotification] = useState(null);
  const [showRealtimeToast, setShowRealtimeToast] = useState(false);

  const handleQuickMenuToggle = () => {
    setIsQuickMenuOpen(!isQuickMenuOpen);
    console.log('Quick menu toggled');
  };

  // Alert action boxes
  const alertActions = [
    {
      id: 'all-alerts',
      icon: 'Bell',
      label: 'جميع التنبيهات',
      color: '#3B82F6',
      bgGradient: 'linear-gradient(135deg, rgba(59, 130, 246, 0.2) 0%, rgba(96, 165, 250, 0.25) 100%)',
      borderColor: 'rgba(59, 130, 246, 0.5)',
      onClick: () => setShowAllAlertsModal(true)
    },
    {
      id: 'client-followup',
      icon: 'Users',
      label: 'متابعة العملاء',
      color: '#10B981',
      bgGradient: 'linear-gradient(135deg, rgba(16, 185, 129, 0.2) 0%, rgba(52, 211, 153, 0.25) 100%)',
      borderColor: 'rgba(16, 185, 129, 0.5)',
      onClick: () => setShowClientFollowUpModal(true)
    },
    {
      id: 'contract-deadline',
      icon: 'FileText',
      label: 'مواعيد العقود',
      color: '#F59E0B',
      bgGradient: 'linear-gradient(135deg, rgba(245, 158, 11, 0.2) 0%, rgba(251, 191, 36, 0.25) 100%)',
      borderColor: 'rgba(245, 158, 11, 0.5)',
      onClick: () => setShowContractDeadlineModal(true)
    },
    {
      id: 'property-expiration',
      icon: 'Building2',
      label: 'انتهاء العقارات',
      color: '#EF4444',
      bgGradient: 'linear-gradient(135deg, rgba(239, 68, 68, 0.2) 0%, rgba(248, 113, 113, 0.25) 100%)',
      borderColor: 'rgba(239, 68, 68, 0.5)',
      onClick: () => setShowPropertyExpirationModal(true)
    },
    {
      id: 'payment-reminder',
      icon: 'DollarSign',
      label: 'تذكير الدفع',
      color: '#8B5CF6',
      bgGradient: 'linear-gradient(135deg, rgba(139, 92, 246, 0.2) 0%, rgba(167, 139, 250, 0.25) 100%)',
      borderColor: 'rgba(139, 92, 246, 0.5)',
      onClick: () => setShowPaymentReminderModal(true)
    },
    {
      id: 'maintenance-alert',
      icon: 'Wrench',
      label: 'تنبيهات الصيانة',
      color: '#06B6D4',
      bgGradient: 'linear-gradient(135deg, rgba(6, 182, 212, 0.2) 0%, rgba(34, 211, 238, 0.25) 100%)',
      borderColor: 'rgba(6, 182, 212, 0.5)',
      onClick: () => setShowMaintenanceAlertModal(true)
    },
    {
      id: 'export-alerts',
      icon: 'Download',
      label: 'تصدير التقرير',
      color: '#EC4899',
      bgGradient: 'linear-gradient(135deg, rgba(236, 72, 153, 0.2) 0%, rgba(244, 114, 182, 0.25) 100%)',
      borderColor: 'rgba(236, 72, 153, 0.5)',
      onClick: () => setShowExportAlertsModal(true)
    },
    {
      id: 'alert-settings',
      icon: 'Settings',
      label: 'إعدادات التنبيهات',
      color: '#14B8A6',
      bgGradient: 'linear-gradient(135deg, rgba(20, 184, 166, 0.2) 0%, rgba(45, 212, 191, 0.25) 100%)',
      borderColor: 'rgba(20, 184, 166, 0.5)',
      onClick: () => setShowAlertSettingsModal(true)
    }
  ];

  const quickActions = [
    {
      label: 'تصدير التقرير',
      icon: 'Download',
      onClick: () => console.log('Export alerts'),
      roles: ['admin'],
      variant: 'default'
    },
    {
      label: 'إعدادات التنبيهات',
      icon: 'Settings',
      onClick: () => console.log('Alert settings'),
      roles: ['admin'],
      variant: 'default'
    }
  ];

  const mockAlerts = [
    {
      id: 'ALT-001',
      type: 'client_followup',
      title: 'متابعة عميل متأخرة',
      description: 'متابعة العميل أحمد محمد السعيد متأخرة بيومين',
      priority: 'urgent',
      status: 'unread',
      assignedTo: 'سارة أحمد',
      assignedToId: 'staff_1',
      createdAt: '٢٠٢٦/٠١/١٠ - ٠٩:٣٠ ص',
      dueDate: '٢٠٢٦/٠١/٠٨',
      clientName: 'أحمد محمد السعيد',
      propertyTitle: 'فيلا فاخرة في حي الملقا',
      escalated: true,
      comments: []
    },
    {
      id: 'ALT-002',
      type: 'contract_deadline',
      title: 'موعد موافقة عقد قريب',
      description: 'عقد CNT-2026-001 يتطلب موافقة خلال 24 ساعة',
      priority: 'high',
      status: 'unread',
      assignedTo: 'أحمد محمد',
      assignedToId: 'staff_2',
      createdAt: '٢٠٢٦/٠١/١٠ - ١٠:١٥ ص',
      dueDate: '٢٠٢٦/٠١/١١',
      contractNumber: 'CNT-2026-001',
      propertyTitle: 'شقة فاخرة في دبي مارينا',
      escalated: false,
      comments: []
    },
    {
      id: 'ALT-003',
      type: 'property_expiration',
      title: 'انتهاء صلاحية إعلان عقار',
      description: 'إعلان العقار PROP-2026-015 سينتهي خلال 3 أيام',
      priority: 'medium',
      status: 'acknowledged',
      assignedTo: 'محمد خالد',
      assignedToId: 'staff_3',
      createdAt: '٢٠٢٦/٠١/٠٩ - ٠٢:٤٥ م',
      dueDate: '٢٠٢٦/٠١/١٣',
      propertyId: 'PROP-2026-015',
      propertyTitle: 'مكتب تجاري في الشميساني',
      escalated: false,
      comments: [
        {
          id: 1,
          author: 'محمد خالد',
          date: '٢٠٢٦/٠١/٠٩ - ٠٢:٤٥ م',
          text: 'تم التواصل مع المالك لتجديد الإعلان'
        }
      ]
    },
    {
      id: 'ALT-004',
      type: 'system_notification',
      title: 'تحديث النظام المجدول',
      description: 'سيتم إجراء صيانة للنظام يوم الجمعة من 12 ص إلى 4 ص',
      priority: 'low',
      status: 'read',
      assignedTo: 'جميع الموظفين',
      assignedToId: 'all',
      createdAt: '٢٠٢٦/٠١/٠٨ - ١١:٠٠ ص',
      dueDate: '٢٠٢٦/٠١/١٢',
      escalated: false,
      comments: []
    },
    {
      id: 'ALT-005',
      type: 'client_followup',
      title: 'طلب معاينة عقار',
      description: 'العميلة فاطمة خالد طلبت معاينة فيلا في الريم',
      priority: 'high',
      status: 'in_progress',
      assignedTo: 'سارة أحمد',
      assignedToId: 'staff_1',
      createdAt: '٢٠٢٦/٠١/١٠ - ١١:٣٠ ص',
      dueDate: '٢٠٢٦/٠١/١١',
      clientName: 'فاطمة خالد المنصوري',
      propertyTitle: 'فيلا مستقلة في الريم',
      escalated: false,
      comments: [
        {
          id: 1,
          author: 'سارة أحمد',
          date: '٢٠٢٦/٠١/١٠ - ١١:٤٥ ص',
          text: 'تم تحديد موعد المعاينة ليوم غد الساعة 3 مساءً'
        }
      ]
    },
    {
      id: 'ALT-006',
      type: 'property_update',
      title: 'تحديث معلومات عقار مطلوب',
      description: 'العقار PROP-2026-008 يحتاج تحديث الصور والوصف',
      priority: 'medium',
      status: 'unread',
      assignedTo: 'محمد خالد',
      assignedToId: 'staff_3',
      createdAt: '٢٠٢٦/٠١/١٠ - ٠٨:٢٠ ص',
      dueDate: '٢٠٢٦/٠١/١٢',
      propertyId: 'PROP-2026-008',
      propertyTitle: 'شقة عصرية في خلدا',
      escalated: false,
      comments: []
    }
  ];

  // Setup real-time subscriptions for alerts
  useEffect(() => {
    // Subscribe to alert changes
    const unsubscribeAlerts = realtimeNotificationService?.subscribeToAlerts((notification) => {
      console.log('Real-time alert update:', notification);
      
      // Show toast notification
      const message = notification?.event === 'INSERT' ?'تنبيه جديد: ' + (notification?.data?.title || 'تنبيه للفريق')
        : notification?.event === 'UPDATE' ?'تم تحديث تنبيه' :'تم حذف تنبيه';
      
      setRealtimeNotification({
        message,
        type: 'alert',
        data: notification?.data,
        priority: notification?.data?.priority || 'medium'
      });
      setShowRealtimeToast(true);
      
      // Auto-hide toast after 5 seconds
      setTimeout(() => setShowRealtimeToast(false), 5000);
    });

    // Subscribe to contract changes (for contract deadline alerts)
    const unsubscribeContracts = realtimeNotificationService?.subscribeToContracts((notification) => {
      console.log('Real-time contract update for alerts:', notification);
      
      if (notification?.event === 'INSERT' || notification?.event === 'UPDATE') {
        const message = 'تحديث في العقود - قد يتطلب متابعة';
        
        setRealtimeNotification({
          message,
          type: 'contract_update',
          data: notification?.data,
          priority: 'medium'
        });
        setShowRealtimeToast(true);
        setTimeout(() => setShowRealtimeToast(false), 5000);
      }
    });

    // Subscribe to client changes (for client follow-up alerts)
    const unsubscribeClients = realtimeNotificationService?.subscribeToClients((notification) => {
      console.log('Real-time client update for alerts:', notification);
      
      if (notification?.event === 'INSERT') {
        const message = 'عميل جديد - يتطلب متابعة';
        
        setRealtimeNotification({
          message,
          type: 'new_client',
          data: notification?.data,
          priority: notification?.data?.priority || 'medium'
        });
        setShowRealtimeToast(true);
        setTimeout(() => setShowRealtimeToast(false), 5000);
      }
    });

    // Cleanup subscriptions on unmount
    return () => {
      unsubscribeAlerts();
      unsubscribeContracts();
      unsubscribeClients();
    };
  }, []);

  // Subscribe to notification service
  const [liveNotifications, setLiveNotifications] = useState([]);

  useEffect(() => {
    const unsubscribe = notificationService?.subscribe((notifications) => {
      setLiveNotifications(notifications);
      
      // Show toast for new notifications
      if (notifications?.length > 0 && notifications?.[0]?.status === 'unread') {
        const latestNotification = notifications?.[0];
        setToastNotification({
          type: latestNotification?.priority === 'high' ? 'warning' : 'info',
          title: 'تنبيه جديد',
          message: latestNotification?.title,
          timestamp: new Date()?.toISOString()
        });
      }
    });

    return () => unsubscribe();
  }, []);

  // Combine mock alerts with live notifications
  const allAlerts = useMemo(() => {
    return [...liveNotifications, ...mockAlerts];
  }, [liveNotifications]);

  const categories = [
    { id: 'all', label: 'جميع التنبيهات', icon: 'Bell', count: allAlerts?.length },
    { id: 'client_interest', label: 'اهتمامات العملاء', icon: 'Users', count: allAlerts?.filter(a => a?.type === 'client_interest')?.length },
    { id: 'client_followup', label: 'متابعات العملاء', icon: 'Users', count: allAlerts?.filter(a => a?.type === 'client_followup')?.length },
    { id: 'contract_deadline', label: 'مواعيد العقود', icon: 'FileText', count: allAlerts?.filter(a => a?.type === 'contract_deadline')?.length },
    { id: 'property_expiration', label: 'انتهاء صلاحية العقارات', icon: 'Home', count: allAlerts?.filter(a => a?.type === 'property_expiration')?.length },
    { id: 'property_update', label: 'تحديثات العقارات', icon: 'RefreshCw', count: allAlerts?.filter(a => a?.type === 'property_update')?.length },
    { id: 'system_notification', label: 'إشعارات النظام', icon: 'Settings', count: allAlerts?.filter(a => a?.type === 'system_notification')?.length }
  ];

  const filteredAlerts = useMemo(() => {
    return allAlerts?.filter(alert => {
      if (selectedCategory !== 'all' && alert?.type !== selectedCategory) return false;
      if (filters?.search && !alert?.title?.includes(filters?.search) && !alert?.description?.includes(filters?.search)) return false;
      if (filters?.priority !== 'all' && alert?.priority !== filters?.priority) return false;
      if (filters?.status !== 'all' && alert?.status !== filters?.status) return false;
      if (filters?.assignedStaff !== 'all' && alert?.assignedToId !== filters?.assignedStaff) return false;
      return true;
    });
  }, [selectedCategory, filters, allAlerts]);

  const unreadCount = allAlerts?.filter(a => a?.status === 'unread')?.length;
  const urgentCount = allAlerts?.filter(a => a?.priority === 'urgent' || a?.priority === 'high')?.length;

  const handleAcknowledge = (alertId) => {
    notificationService?.updateNotificationStatus(alertId, 'acknowledged');
  };

  const handleResolve = (alertId) => {
    notificationService?.updateNotificationStatus(alertId, 'read');
    setToastNotification({
      type: 'success',
      title: 'تم الحل',
      message: 'تم حل التنبيه بنجاح',
      timestamp: new Date()?.toISOString()
    });
  };

  const handleEscalate = (alertId) => {
    const alert = allAlerts?.find(a => a?.id === alertId);
    if (alert) {
      notificationService?.escalateNotification(alertId, 'supervisor', (alert?.escalationLevel || 0) + 1);
      setToastNotification({
        type: 'warning',
        title: 'تم التصعيد',
        message: 'تم تصعيد التنبيه إلى المشرف',
        timestamp: new Date()?.toISOString()
      });
    }
  };

  const handleAssign = (alertId, staffId) => {
    notificationService?.reassignNotification(alertId, staffId);
    setToastNotification({
      type: 'info',
      title: 'تم التوكيل',
      message: 'تم توكيل التنبيه بنجاح',
      timestamp: new Date()?.toISOString()
    });
  };

  const handleAddComment = (alertId, comment) => {
    notificationService?.addComment(alertId, comment);
  };

  const handleUpdateTask = (notificationId, taskId, status) => {
    notificationService?.updateTaskStatus(notificationId, taskId, status);
    setToastNotification({
      type: 'success',
      title: 'تحديث المهمة',
      message: `تم تحديث حالة المهمة إلى ${status === 'completed' ? 'مكتمل' : status === 'in_progress' ? 'قيد التنفيذ' : 'قيد الانتظار'}`,
      timestamp: new Date()?.toISOString()
    });
  };

  return (
    <Layout
      userRole="admin"
      userName="أحمد محمد"
      onQuickMenuToggle={() => setIsQuickMenuOpen(!isQuickMenuOpen)}
    >
      <SubHeader pageTitle="التنبيهات والإشعارات" />
      <ActionBoxes 
        actions={alertActions}
        showNewContractModal={showNewContractModal}
        setShowNewContractModal={setShowNewContractModal}
        contractTypeConfig={{}}
      />
      <div className="min-h-screen bg-background p-4 md:p-6 lg:p-8">

        <div className="p-4 md:p-6 space-y-4 md:space-y-6">
          {/* Header with Stats */}
          <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
            <div>
              <h1 className="text-2xl md:text-3xl font-heading font-bold text-foreground mb-2">
                لوحة تنبيهات الموظفين
              </h1>
              <p className="text-sm md:text-base text-muted-foreground">
                إدارة ومتابعة التنبيهات والمهام الموكلة للموظفين
              </p>
            </div>
            <div className="flex items-center gap-3">
              <div className="px-4 py-2 bg-error/10 border border-error/30 rounded-lg">
                <div className="flex items-center gap-2">
                  <Icon name="AlertCircle" size={20} className="text-error" />
                  <div>
                    <p className="text-xs text-muted-foreground">عاجل</p>
                    <p className="text-lg font-bold text-error">{urgentCount}</p>
                  </div>
                </div>
              </div>
              <div className="px-4 py-2 bg-warning/10 border border-warning/30 rounded-lg">
                <div className="flex items-center gap-2">
                  <Icon name="Bell" size={20} className="text-warning" />
                  <div>
                    <p className="text-xs text-muted-foreground">غير مقروء</p>
                    <p className="text-lg font-bold text-warning">{unreadCount}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Main Content */}
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-4 md:gap-6">
            {/* Left Sidebar - Categories */}
            <div className="lg:col-span-3">
              <AlertCategories
                categories={categories}
                selectedCategory={selectedCategory}
                onSelectCategory={setSelectedCategory}
              />
            </div>

            {/* Center - Alert Feed */}
            <div className="lg:col-span-5">
              <AlertFilterBar filters={filters} onFiltersChange={setFilters} />
              <AlertFeed
                alerts={filteredAlerts}
                selectedAlert={selectedAlert}
                onSelectAlert={setSelectedAlert}
                onAcknowledge={handleAcknowledge}
                onResolve={handleResolve}
              />
            </div>

            {/* Right Sidebar - Alert Details */}
            <div className="lg:col-span-4 space-y-4">
              <AlertDetails
                alert={selectedAlert}
                onResolve={handleResolve}
                onEscalate={handleEscalate}
                onAssign={handleAssign}
                onAddComment={handleAddComment}
              />
              
              {selectedAlert && (
                <TaskManagementPanel
                  notification={selectedAlert}
                  onUpdateTask={handleUpdateTask}
                  onClose={() => setSelectedAlert(null)}
                />
              )}
            </div>
          </div>
        </div>
      </div>
      {/* Toast Notification */}
      <NotificationToast
        notification={toastNotification}
        onClose={() => setToastNotification(null)}
      />
      {/* Action Modals */}
      <AllAlertsActionsModal 
        isOpen={showAllAlertsModal} 
        onClose={() => setShowAllAlertsModal(false)} 
      />
      <ClientFollowUpActionsModal 
        isOpen={showClientFollowUpModal} 
        onClose={() => setShowClientFollowUpModal(false)} 
      />
      <ContractDeadlineActionsModal 
        isOpen={showContractDeadlineModal} 
        onClose={() => setShowContractDeadlineModal(false)} 
      />
      <PropertyExpirationActionsModal 
        isOpen={showPropertyExpirationModal} 
        onClose={() => setShowPropertyExpirationModal(false)} 
      />
      <PaymentReminderActionsModal 
        isOpen={showPaymentReminderModal} 
        onClose={() => setShowPaymentReminderModal(false)} 
      />
      <MaintenanceAlertActionsModal 
        isOpen={showMaintenanceAlertModal} 
        onClose={() => setShowMaintenanceAlertModal(false)} 
      />
      <ExportAlertsModal 
        isOpen={showExportAlertsModal} 
        onClose={() => setShowExportAlertsModal(false)} 
      />
      <AlertSettingsModal 
        isOpen={showAlertSettingsModal} 
        onClose={() => setShowAlertSettingsModal(false)} 
      />
      {/* Real-time notification toast */}
      {showRealtimeToast && realtimeNotification && (
        <div className="fixed top-20 left-1/2 transform -translate-x-1/2 z-50 animate-slide-down">
          <div className={`bg-white rounded-lg shadow-2xl border-r-4 p-4 min-w-[300px] max-w-md ${
            realtimeNotification?.priority === 'high' ?'border-red-500' 
              : realtimeNotification?.priority === 'medium' ?'border-yellow-500' :'border-blue-500'
          }`}>
            <div className="flex items-start gap-3">
              <div className="flex-shrink-0">
                <div className={`w-10 h-10 rounded-full flex items-center justify-center ${
                  realtimeNotification?.priority === 'high' ?'bg-red-100'
                    : realtimeNotification?.priority === 'medium' ?'bg-yellow-100' :'bg-blue-100'
                }`}>
                  <Icon 
                    name="Bell" 
                    className={`w-5 h-5 ${
                      realtimeNotification?.priority === 'high' ?'text-red-600'
                        : realtimeNotification?.priority === 'medium' ?'text-yellow-600' :'text-blue-600'
                    }`} 
                  />
                </div>
              </div>
              <div className="flex-1">
                <h4 className="text-sm font-semibold text-gray-900 mb-1">
                  تنبيه فوري
                </h4>
                <p className="text-sm text-gray-700">
                  {realtimeNotification?.message}
                </p>
                <p className="text-xs text-gray-500 mt-1">
                  {new Date()?.toLocaleTimeString('ar-JO', { hour: '2-digit', minute: '2-digit' })}
                </p>
              </div>
              <button
                onClick={() => setShowRealtimeToast(false)}
                className="flex-shrink-0 text-gray-400 hover:text-gray-600"
              >
                <Icon name="X" className="w-4 h-4" />
              </button>
            </div>
          </div>
        </div>
      )}
    </Layout>
  );
};

export default StaffAlertAndNotificationDashboard;